// extracted by mini-css-extract-plugin
module.exports = {"main":"DoctorStyles_main__Yd-4h","calendar":"DoctorStyles_calendar__3qHtf"};